import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "../../css/shipping.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const Shipping = () => {
  const { t } = useTranslation();
  const rows = useMemo(() => {
    const raw = t("shippingPage.rows", { returnObjects: true });
    return Array.isArray(raw) ? raw : [];
  }, [t]);

  return (
    <div className="shipping-page">
      <Header />
      <main className="shipping__main">
        <div className="shipping__inner">
          <nav
            className="shipping__breadcrumb"
            aria-label={t("shippingPage.breadcrumbAria")}
          >
            <Link to="/" className="shipping__breadcrumb-link">
              {t("shippingPage.breadcrumb")}
            </Link>
          </nav>



          <h1 className="shipping__title">{t("shippingPage.title")}</h1>
          <p className="shipping__subtitle">{t("shippingPage.subtitle")}</p>

          <div className="shipping__promo" role="region" aria-label={t("shippingPage.promoAria")}>
            <svg
              className="w-6 h-6 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>

            <p className="shipping__promo-text">
              <span className="shipping__promo-lead">{t("shippingPage.promoLead")}</span>
              <span className="shipping__promo-detail">{t("shippingPage.promoDetail")}</span>
            </p>
          </div>

          <div className="shipping__table-wrap">
            <table className="shipping__table">
              <thead>
                <tr>
                  <th scope="col">{t("shippingPage.colDestination")}</th>
                  <th scope="col">{t("shippingPage.colStandard")}</th>
                  <th scope="col">{t("shippingPage.colExpress")}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={`ship-row-${idx}`}>
                    <td className="shipping__dest">{row.destination}</td>
                    <td>
                      <div className="shipping__std-stack">
                        <span className="shipping__days">{row.standardDays}</span>
                        <span className="shipping__price">{row.standardPrice}</span>
                      </div>
                    </td>
                    <td>
                      {row.express ? (
                        <span className="shipping__price">{row.express}</span>
                      ) : (
                        <span className="shipping__express-empty">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <section className="shipping__block" aria-labelledby="shipping-process-heading">
            <h2 id="shipping-process-heading" className="shipping__block-title">
              {t("shippingPage.processTitle")}
            </h2>
            <p className="shipping__block-text">{t("shippingPage.processBody")}</p>
          </section>

          <section className="shipping__block" aria-labelledby="shipping-tracking-heading">
            <h2 id="shipping-tracking-heading" className="shipping__block-title">
              {t("shippingPage.trackingTitle")}
            </h2>
            <p className="shipping__block-text">{t("shippingPage.trackingBody")}</p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Shipping;
